var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box-logo flex align-center",class:{'nav-collapsed':_vm.collapseNav, [_vm.mode]:true}},[_c('img',{staticClass:"image-logo",attrs:{"src":_vm.thumbnail,"alt":"logo"}}),_c('button',{staticClass:"collapse-nav",on:{"click":_vm.collapseNavToggle}},[_c('i',{staticClass:"mdi mdi-menu"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }